"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "force": {
    "0205c139": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "bolognano": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3d0e8cbb": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "case-agasucci": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9007b074": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "cese": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d1a8f3df": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "colle-riccardo": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ca75ae02": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "fonteviva": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "eb76a696": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "le-palombare": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ee7bf811": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "madonna-del-lago": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6659eea4": [{
      "hkey": "a9bdcc73",
      "slug": "montecchio-santo-stefano",
      "name": "Montecchio-Santo Stefano",
      "primary": true,
      "skipSearch": false
    }],
    "montecchio": [{
      "hkey": "a9bdcc73",
      "slug": "montecchio-santo-stefano",
      "name": "Montecchio-Santo Stefano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bc13c996": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "san-giovanni": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "67e057ba": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "san-taddeo": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b90e174e": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "san-vincenzo": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7864870c": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "af8bc93b": [{
      "hkey": "a9bdcc73",
      "slug": "montecchio-santo-stefano",
      "name": "Montecchio-Santo Stefano",
      "primary": true,
      "skipSearch": false
    }],
    "santo-stefano": [{
      "hkey": "a9bdcc73",
      "slug": "montecchio-santo-stefano",
      "name": "Montecchio-Santo Stefano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "force"
    }],
    "496a1311": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "vaccareccia": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "14cb89fe": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "skipSearch": false
    }],
    "villa-leva": [{
      "hkey": "4e8e91d1",
      "slug": "force",
      "name": "Force",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;